var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTop3Creator = function SvgTop3Creator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__a)",
    fillRule: "evenodd",
    d: "m27.481 29.182-9.28-9.282L.782 37.318a.75.75 0 0 0 .471 1.279c1.54.118 3.617.28 3.617.28l4.712-1.058L8.514 42.5l.274 3.623a.75.75 0 0 0 1.28.472z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__b)",
    fillRule: "evenodd",
    d: "m20.534 29.182 9.281-9.282 17.418 17.418a.75.75 0 0 1-.471 1.279c-1.54.118-3.618.28-3.618.28l-4.304-.65.661 4.273s-.158 2.08-.273 3.623a.75.75 0 0 1-1.28.472z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__c)",
    fillRule: "evenodd",
    d: "m4.823 38.8 16.139-16.139 3.63 3.63-16.14 16.14-.222-3.387z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__d)",
    fillRule: "evenodd",
    d: "m43.195 38.8-16.14-16.139-3.63 3.63 16.14 16.14.222-3.387z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__e)",
    fillRule: "evenodd",
    d: "M29.558 6.365a1.96 1.96 0 0 1 1.38.572c1.642 1.645 6.368 6.375 8.011 8.018.366.366.57.861.57 1.379 0 2.323-.003 9.01-.002 11.334a1.96 1.96 0 0 1-.572 1.38c-1.645 1.641-6.375 6.368-8.018 8.011-.366.366-.861.57-1.379.57-2.323 0-9.01-.003-11.334-.002a1.96 1.96 0 0 1-1.38-.572c-1.641-1.645-6.368-6.375-8.011-8.018a1.96 1.96 0 0 1-.57-1.379c0-2.323.003-9.01.002-11.334a1.96 1.96 0 0 1 .572-1.38c1.645-1.642 6.375-6.368 8.018-8.011.366-.366.861-.57 1.379-.57 2.323 0 9.01.003 11.334.002",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__f)",
    fillRule: "evenodd",
    d: "M28.565 9.87a.87.87 0 0 1 .617.256c1.106 1.106 5.455 5.454 6.559 6.56a.88.88 0 0 1 .257.62l-.002 9.277a.87.87 0 0 1-.256.617c-1.106 1.106-5.454 5.455-6.56 6.559a.88.88 0 0 1-.62.257l-9.277-.002a.87.87 0 0 1-.617-.256l-6.559-6.56a.88.88 0 0 1-.257-.621l.002-9.276a.87.87 0 0 1 .256-.617c1.106-1.106 5.454-5.455 6.56-6.559a.88.88 0 0 1 .62-.257z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#top-3-creator_svg__g)",
    fillRule: "evenodd",
    d: "m28.586 10.876 6.483 6.484v9.168l-6.484 6.483h-9.17l-6.482-6.484v-9.169l6.484-6.483z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#763C00",
    d: "M23.822 8.794a.714.714 0 1 0 0-1.428.714.714 0 0 0 0 1.428M33.232 12.792a.714.714 0 1 0 1.01-1.01.714.714 0 0 0-1.01 1.01M36.948 21.908a.714.714 0 1 0 1.428 0 .714.714 0 0 0-1.428 0M32.949 31.318a.714.714 0 1 0 1.01 1.01.714.714 0 0 0-1.01-1.01M23.835 35.033a.714.714 0 1 0 0 1.428.714.714 0 0 0 0-1.428M14.424 31.035a.714.714 0 1 0-1.01 1.01.714.714 0 0 0 1.01-1.01M10.708 21.921a.714.714 0 1 0-1.428 0 .714.714 0 0 0 1.428 0M14.706 12.509a.714.714 0 1 0-1.01-1.01.714.714 0 0 0 1.01 1.01"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__a",
    x1: 21.003,
    x2: 7.313,
    y1: 26.379,
    y2: 40.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__b",
    x1: 27.013,
    x2: 40.703,
    y1: 26.379,
    y2: 40.069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C2F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__c",
    x1: 16.015,
    x2: 6.601,
    y1: 31.243,
    y2: 40.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__d",
    x1: 32.002,
    x2: 41.417,
    y1: 31.243,
    y2: 40.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAD3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__e",
    x1: 36.112,
    x2: 12.011,
    y1: 10.914,
    y2: 34.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9AA57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965B31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__f",
    x1: 18.696,
    x2: 29.337,
    y1: 14.961,
    y2: 27.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F9AA57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#965B31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "top-3-creator_svg__g",
    x1: 14.737,
    x2: 34.882,
    y1: 10.859,
    y2: 37.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A55400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D1F00"
  })))));
};
export default SvgTop3Creator;